import { render, staticRenderFns } from "./ComponentAgentRecivable.vue?vue&type=template&id=74efaac3&scoped=true"
import script from "./ComponentAgentRecivable.vue?vue&type=script&lang=js"
export * from "./ComponentAgentRecivable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74efaac3",
  null
  
)

export default component.exports